// extracted by mini-css-extract-plugin
export var component = "PostsModuleHeader-module--component--cZkHr";
export var link = "PostsModuleHeader-module--link--0WTol";
export var linkIcon = "PostsModuleHeader-module--linkIcon--LaNqk";
export var title = "PostsModuleHeader-module--title--SLTiy";